export const isEmpty = (value) => !value.trim();

export const isEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const minLength = (value, length) => value.length >= length;
export const methods = {
    requiredMethods: (value,parameter) => { if(!value.trim()){ return false;}else{ return true}},
    requiredMethodsnot: (value,parameter) => {  return true},
    emailMethods: (email,parameter) =>  { let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; return re.test(email)},
    validName: (value,parameter) => {
   let re = /^[a-zA-Z ]{2,50}$/; return re.test(value)
},
minLength: (value,parameter) =>{
   var len = value.length;
   var minParameter = null
    if (Array.isArray(parameter) && parameter.length > 0) {
      minParameter = parameter[0].min
    }
        if(len <= minParameter){
          return false;
        }
        else{
          return true;
        }
},
   validnumber: (value,parameter) => {
   let re = /^\d*$/; return re.test(value)
},
   validphonenumbre: (value,parameter) => {
    //new RegExp(`^\\+?\\d{1,4}\\s?\\d{${parameter.min},${parameter.max}}$`)
   let re = /^(\+?\d{1,4})?\s?\d{8,10}$/; 
  // let re = new RegExp(`^\\+?\\d{1,4}\\s?\\d{${parameter.min},${parameter.max}}$`); 
   return re.test(value)
},
  validminmax: (value,parameter) => {
    let min = null;
    let max = null;
    let regex;
    if(parameter.min){
        min = parameter.min;
    }
    if(parameter.max){
         max = parameter.max;
    }
    if(min != null && max != null){
        regex = new RegExp(`^.{${min},${max}}$`);
    }else if(min != null){
    regex = new RegExp(`^.{${min},}$`);
    }else if(max != null){
    regex = new RegExp(`^.{$,${max}}$`);
    }else{
      regex =  /^.{3,20}$/;
    }

    return regex.test(value)

  },
     checkConfirmpassword: (confirmpassword,password) => {
      let checkpassword ='';
         if (Array.isArray(password) && password.length > 0) {
      
        checkpassword  = password[0].password
    }
   
        if(confirmpassword == checkpassword){
          return true;
        }
        else{
          return false;
        }
      },
};